var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app",class:{
    main__app: _vm.mainPage,
  }},[_c('header',{staticClass:"header-component",class:{
      loginPage__header: _vm.loginPage,
      workflowPage__header: _vm.workflowPage,
      filesPage__header: _vm.filesPage,
      datasetsPage__header: _vm.datasetsPage,
      adminPage__header: _vm.adminPage,
      tutorialPage__header: _vm.tutorialPage,
    }},[_c('CellcraftHeader')],1),_c('main',{staticClass:"main-component",class:{
      loginPage__main: _vm.loginPage,
      workflowPage__main: _vm.workflowPage,
      filesPage__main: _vm.filesPage,
      datasetsPage__main: _vm.datasetsPage,
      adminPage__main: _vm.adminPage,
    }},[_c('router-view')],1),_c('footer',{staticClass:"footer-component",class:{
      loginPage__footer: _vm.loginPage,
      workflowPage__footer: _vm.workflowPage,
      filesPage__footer: _vm.filesPage,
      datasetsPage__footer: _vm.datasetsPage,
      adminPage__footer: _vm.adminPage,
    }},[_c('div',{staticClass:"copyright__txt"},[_vm._v("CELLCRAFT © 2023. All rights reserved")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }